import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {InvoiceService} from '../../../../shared/services/invoice.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ChangeStatusData} from '../change-status-dialog/change-status-dialog.component';
import {Invoice} from '../../../../shared/interface/invoice';
import {FileBase64} from '../../../../shared/components/file-drag-and-drop/file-drag-and-drop.component';
import {first} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {FormHelperService} from "../../../../shared/services/form-helper.service";

export interface CreateDocumentData {
  invoice: Invoice;
}

@Component({
  selector: 'app-create-document-dialog',
  templateUrl: './create-document-dialog.component.html',
  styleUrls: ['./create-document-dialog.component.scss']
})
export class CreateDocumentDialogComponent implements OnInit {

  documentForm: FormGroup;
  typeControl: FormControl;
  fileContentControl: FormControl;
  fileNameControl: FormControl;
  numberControl: FormControl;
  netControl: FormControl;
  issueDateControl: FormControl;
  reasonControl: FormControl;
  errors: any = {};
  processingRequest = false;
  fileMaxSize = 5242880;

  constructor(
    public dialogRef: MatDialogRef<CreateDocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateDocumentData,
    private fb: FormBuilder,
    private invoiceService: InvoiceService,
    private snackBar: MatSnackBar,
    private formHelper: FormHelperService,
  ) {
    this.documentForm = fb.group({
      type: this.typeControl = fb.control('', [Validators.required]),
      fileContent: this.fileContentControl = fb.control('', [Validators.required]),
      fileName: this.fileNameControl = fb.control(''),
      number: this.numberControl = fb.control('', [Validators.required]),
      net: this.netControl = fb.control('', [Validators.required]),
      issueDate: this.issueDateControl = fb.control('', [Validators.required]),
      reason: this.reasonControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  fileSelected($event: FileBase64): void {
    this.fileNameControl.setValue($event?.filename);
    this.fileContentControl.setValue($event?.base64);
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  save(): void {
    this.processingRequest = true;
    this.invoiceService.addDocument(
      this.data.invoice.uuid,
      this.documentForm.value
    )
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snackBar.open('Pomyślnie utworzono notę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.documentForm, this.errors);
        }
      });
  }
}
